import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import TotalIndustryCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalIndustryCard'
import TotalIndustryByZones from 'src/components/reports/reportsBoard/MarketShareReports/TotalIndustryByZones'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))

const TotalIndustriCompanyPage = props => {
  const { selectedDate, handleDateChange } = props
  const classes = useStyles()
  const history = useHistory()

  return (
    <>
      <CardTitle
        title="Total Indústria por compañía"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <TotalIndustryCard {...props} />
      <TotalIndustryByZones {...props} />
    </>
  )
}

export default memo(TotalIndustriCompanyPage)
